import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CmsConfig, ConfigModule, I18nModule, provideConfig, provideDefaultConfig } from '@spartacus/core';
import { OrderConfirmationGuard, OrderConfirmationModule, OrderConfirmationThankYouMessageComponent, OrderDetailsService } from '@spartacus/order/components';
import { OrderFacade } from '@spartacus/order/root';
import {
  CardModule,
  FormErrorsModule,
  OutletModule,
  PasswordVisibilityToggleModule,
  PromotionsModule,
  PwaModule,
} from '@spartacus/storefront';
import { UdxB2bCartSharedModule } from '../../cart-shared/cart-shared.module';
import { UdxOrderDetailShippingComponent } from '../order-details/order-details-shipping/udx-order-detail-shipping.component';
import { UdxOrderConfirmationItemsComponent } from './order-confirmation-items/udx-order-confirmation-items.component';
import { UdxOrderConfirmationTotalsComponent } from './order-confirmation-totals/order-confirmation-totals.component';
import { UDXOrderConfirmationThankYouMessageComponent } from './order-confirmation-thank-you-message/udx-order-confirmation-thank-you-message.component';

@NgModule({
    exports: [UdxOrderConfirmationItemsComponent, UdxOrderConfirmationTotalsComponent],
    imports: [
        CommonModule,
        CardModule,
        PwaModule,
        PromotionsModule,
        I18nModule,
        ReactiveFormsModule,
        FormErrorsModule,
        OutletModule,
        PasswordVisibilityToggleModule,
        OrderConfirmationModule,
        ConfigModule.withConfig({
            cmsComponents: {
                OrderConfirmationItemsComponent: {
                    component: UdxOrderConfirmationItemsComponent,
                },
                OrderConfirmationTotalsComponent: {
                    component: UdxOrderConfirmationTotalsComponent,
                    guards: [OrderConfirmationGuard],
                },
            },
        } as CmsConfig),
        UdxB2bCartSharedModule,
        UdxOrderConfirmationItemsComponent, UdxOrderConfirmationTotalsComponent, UDXOrderConfirmationThankYouMessageComponent,
    ],
    providers: [
        provideDefaultConfig(<CmsConfig>{
            cmsComponents: {
                OrderConfirmationOverviewComponent: {
                    component: UdxOrderDetailShippingComponent,
                    providers: [
                        {
                            provide: OrderDetailsService,
                            useExisting: OrderFacade,
                        },
                    ],
                    guards: [OrderConfirmationGuard],
                },
            },
        }),
        provideConfig(<CmsConfig>{
            cmsComponents: {
                OrderConfirmationThankMessageComponent: {
                    component: UDXOrderConfirmationThankYouMessageComponent,
                    guards: [OrderConfirmationGuard],
                },
            },
        })
    ],
})
export class UdxOrderConfirmationModule {}
